export default __webpack_public_path__ + "static/media/icon-next-pagination.19654354.svg";